import { getPublication } from '../../../services/publicationService';

export const enrichArtsWithPublicationStatus = async (arts = []) => {
  if (!Array.isArray(arts) || arts.length === 0) {
    return Array.isArray(arts) ? arts : [];
  }

  return Promise.all(
    arts.map(async (art) => {
      if (!art?.publicationId) {
        return art;
      }

      try {
        const response = await getPublication(art.publicationId);
        const publicationStatus =
          response?.data?.status ||
          art?.publicationStatus ||
          art?.scheduleStatus ||
          'Status indisponível';

        return {
          ...art,
          publicationStatus,
        };
      } catch (error) {
        console.error('[ChatSocketPage] Failed to load publication status', {
          publicationId: art.publicationId,
          error,
        });

        return {
          ...art,
          publicationStatus:
            art?.publicationStatus || art?.scheduleStatus || 'Status indisponível',
        };
      }
    }),
  );
};
